export default function TooltipComponent ({ content, children }) {
  return (
    <div className='relative group inline-block border'>
      {children}
      <div className='absolute right-0 -top-12 z-20 hidden group-hover:flex w-max max-w-[200px] px-3 py-1.5 rounded-md bg-white text-greenPrimary text-xs shadow-md'>
        {content}
        <div className='absolute -bottom-1 right-10 w-2 h-2 bg-gray-100 rotate-45' />
      </div>
    </div>
  )
}
